module.exports = __webpack_public_path__ + "img/ValidatorNode-Checked.44918618.svg";